import { Component } from '@angular/core';
import { TextCardComponent } from "../components/text-card/text-card.component";
import { SharedDataService } from '../../helper/services/shared-data.service';
import { Lesson } from '../../data/models/Lesson';
import { LessonService } from '../../networking/services/lesson.service';

import { LessonCardComponent } from '../components/lesson-card/lesson-card.component';
import { MatButtonModule } from '@angular/material/button';
import { finalize, from } from 'rxjs';
import { CountCardComponent } from "../components/count-card/count-card.component";
import { Router } from '@angular/router';
import { Course } from '../../data/models/Course';
import { CourseService } from '../../networking/services/course.service';
import { DialogService } from '../../helper/services/dialog.service';
import { CourseManagerService } from '../../networking/services/course-manager.service';
import { HelperService } from '../../helper/services/helper.service';
import { LocalStorageService } from '../../helper/services/local-storage.service';
import { LessonPageItemProgress } from '../../data/models/LessonPageItemProgress';
import { LessonPageItemProgressLocal } from '../../data/interfaces/LessonPageItemProgressLocal';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';

@Component({
    selector: 'app-dashboard',
    imports: [TextCardComponent, LessonCardComponent, CountCardComponent, MatButtonModule, MatTooltipModule, MatExpansionModule],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  errorMessage: string = ''
  lessons: Lesson[] = []
  course!: Course
  amountVideos: number = 0
  amountVideosWatched: number = 0
  amountFinishedLessons: number = 0

  constructor(public sharedDataService: SharedDataService, private lessonService: LessonService, private router: Router, private courseService: CourseService, private dialogService: DialogService, private courseManagerService: CourseManagerService, private helperService: HelperService, private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    if(this.isLoggedIn()){
      this.router.navigate(['course-manager/dashboard']);
    }
    this.courseService.getCourseDetails("123e4567-e89b-12d3-a456-426614174000").subscribe((course) => { //Frühchen-Signale
      this.course = course;
    })
    this.lessonService.getLessonListPublished("123e4567-e89b-12d3-a456-426614174000").subscribe((lessons) => {
      this.lessons = lessons;
      
      lessons.forEach(lesson => {
        const key = this.getLocalProgressPerLesson(lesson);
        const progressData = this.localStorageService.get<LessonPageItemProgressLocal[]>(key);

        lesson.amount_of_item_progress = progressData?.length
        lesson.amount_of_videos_watched = progressData?.filter(
          item => item.itemType.title === 'Video'
        ).length;
        if(lesson.amount_of_items > 0){
        if(lesson.amount_of_item_progress){
          lesson.progress = (lesson.amount_of_item_progress / lesson.amount_of_items ) * 100
        } else {
          lesson.progress = 0
        }} else {
          lesson.progress = 100
        }
      });
      
      this.amountVideos = lessons.reduce((sum, lesson) => sum + lesson.amount_of_videos, 0);
      this.amountVideosWatched = lessons.reduce(
        (sum, lesson) => sum + (lesson.amount_of_videos_watched ?? 0),
        0
      );
      this.amountFinishedLessons = lessons.filter(lesson => lesson.progress !== undefined && lesson.progress >= 100).length;
    });
  }

  openLoginDialog(): void {
    this.dialogService.openCourseManagerLoginDialog();
  }

  navigateToLesson(id: string) {
    this.router.navigate(['/lesson', id]);
  }

  isLoggedIn(): boolean {
    return this.helperService.isLoggedIn();
  }

  logout() {
    this.courseManagerService.logoutUser()
  }

  getLocalProgressPerLesson(lesson: Lesson): string {
    return `lessonItemProgress_${lesson.id}`;
  }

  private cleanupObsoleteProgress(validLessonIds: string[]) { //To-do: needs to be reworked because it causes complete progress loss if the backend doesn't respond and no lessons are being fetched
    const allLocalKeys = Object.keys(localStorage).filter(key =>
      key.startsWith('visitedPages_')
    );
  
    for (const key of allLocalKeys) {
      const lessonId = key.replace('visitedPages_', '');
  
      if (!validLessonIds.includes(lessonId)) {
        this.localStorageService.remove(key)
      }
    }
  }

  isLessonUnlocked(index: number): boolean {
    if (index === 0) {
      return true;
    }
    return (this.lessons[index - 1]?.progress ?? 0) >= 100;
  }
}
